import React, {Component} from 'react';
import JapanFlag from '../../../../../assets/img/japanFlag.jpg';
import LatestOrdersList from "./LatestOrdersList";
import "./LatestOrders.css";
import {FormattedMessage} from "react-intl";
import {ProgressBar} from 'react-bootstrap';
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import TodoList from "./ToDoList";

class LatestOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            latestOrdersList: [...LatestOrdersList.orderList],
            selectedOrderList: [],
            orderDetailList: [],
            orderCount: 0
        };
    }

    componentDidMount() {
        let selectedList = [];
        for (let i = 0; i < 6; i++) {
            let item = this.state.latestOrdersList[Math.floor(Math.random() * this.state.latestOrdersList.length)];
            selectedList.push(item)
        }
        let orderCount = this.state.latestOrdersList.length;

        this.setState({
            // selectedOrderList : selectedList,
            orderCount:this.state.latestOrdersList.length,
        });



    }


    static truncate(s) {
        if (s.length > 10) {
            return s.substring(0, 4) + "***";
        } else {
            return s;
        }

    };

    static truncateDate(d) {
        if (d.length > 10) {
            return d.substring(5, 10);
        } else {
            return d;
        }

    }

    render() {
        return (
            <div className="latest-orders-card col-md-12">
                <div className="latest-orders-heading text-center">
                    <h4 className="font-weight-heading">
                        <FormattedMessage id="app.home-content.pcb-service.latest-orders-card.heading"
                                          defaultMessage="The World's Largest Prototype Board Factory"
                                          description=""/>
                    </h4>
                </div>
                <div className="pull-left">
                    <h4 className="font-weight-heading">
                        <FormattedMessage id="app.home-content.pcb-service.latest-orders-card.description1"
                                          defaultMessage="Latest Order"
                                          description=""/>
                    </h4>
                </div>
                <div className="pull-right move-left-div">
                    <h4 className="font-weight-heading">
                        <FormattedMessage id="app.home-content.pcb-service.latest-orders-card.description2"
                                          defaultMessage="Last 30 Days"
                                          description=""/>
                        | <span className="order-count-field ">6</span></h4>
                        {/*| <span className="order-count-field">{this.state.orderCount}</span></h4>*/}
                </div>
                <div className="col-md-12 latest-order-div">
                    <table className="order-table">
                        <thead>
                        <tr className="order-table-th-height">
                            <td className="col-md-3 th-font">
                                {/*<FormattedMessage id="app.home-content.pcb-service.latest-orders-card.date"*/}
                                                  {/*defaultMessage="Date"*/}
                                                  {/*description=""/>*/}
                                日付

                            </td>
                            <td className="col-md-3 th-font ">
                                <FormattedMessage id="app.home-content.pcb-service.latest-orders-card.order-number"
                                                  defaultMessage="Order No."
                                                  description=""/>
                            </td>

                            <td className="col-md-3 th-font">
                                <FormattedMessage id="app.home-content.pcb-service.latest-orders-card.amount"
                                                  defaultMessage="Amount of Money"
                                                  description=""/>
                            </td>
                            <td className="col-md-3 th-font">
                                <FormattedMessage id="app.home-content.pcb-service.latest-orders-card.progress"
                                                  defaultMessage="Progress"
                                                  description=""/>
                            </td>
                        </tr>
                        </thead>

                        {/*{this.state.orderDetailList.map(item=> {
                                let orderStatus = item.status;
                                let itemProgress;

                                if(orderStatus === "PENDING_REVIEW"){
                                    itemProgress = 100/7;
                                }else if(orderStatus === "CANCELED"){
                                    itemProgress = (100/7)*2;
                                }else if(orderStatus === "CONFIRMED"){
                                    itemProgress = (100/7)*3;
                                }else if(orderStatus === "ORDERED"){
                                    itemProgress = (100/7)*4;
                                }else if(orderStatus === "IN_PRODUCTION"){
                                    itemProgress = (100/7)*5;
                                }else if(orderStatus === "SHIPPED"){
                                    itemProgress = (100/7)*6;
                                }else if(orderStatus === "DELIVERED"){
                                    itemProgress = 100;
                                }else {
                                    itemProgress =0;
                                })}*/
                        }

                        <TodoList/>

                    </table>
                </div>
            </div>
        );
    }

}

export default LatestOrders;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/PCBService/LatestOrders/LatestOrders.js